import { Box } from "@mui/material";
import { useCallback, useRef, useState } from "react";
import { AiFillCamera } from "react-icons/ai";
import { IoMdClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Webcam from "react-webcam";
import { ArrowBackPage } from "../../components/ArrowBackPage";
import { Layout } from "../../components/Layout";
import { useAuth } from "../../providers/Auth/Auth";
import style from "./styles.module.scss";

import { SiVerizon } from "react-icons/si";
import { userApi } from "../../providers/User/service";
import { ButtonCaptureCamera } from "../../components/ButtonCamera/ButtonCapture";
import { customToast } from "../../utils/toast";
import { IfLoaderInsideScreen } from "../../components/IfLoaderInsideScreen";
import Swal from "sweetalert2";

export default function Capture() {
  const navigate = useNavigate();
  const webcamRef = useRef<any>();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const { userData } = useAuth();

  const backPage = () => {
    navigate("/home");
  };

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
  }, [webcamRef]);

  const handleClose = useCallback(() => {
    setImage(null);
  }, [setImage]);

  const handleSend = useCallback(
    (isTryAgain = false) => {
      setLoading(true);
      if (!navigator.geolocation) {
        customToast("Seu navegador não suporta geolocalização.", "error");
        setLoading(false);
        navigate("/home");
        return;
      }

      navigator.geolocation.getCurrentPosition(
        function (position: any) {
          const file = dataURLtoFile(image, "image.jpg");

          const formData = new FormData();

          formData.append("selfie", file);
          formData.append("employee_id", userData.employee.id);
          formData.append("latitude", position?.coords?.latitude);
          formData.append("longitude", position?.coords?.longitude);
          formData.append("device_model", "Web");
          formData.append("app_version", "-");

          userApi
            .postPointRegister(userData, formData)
            .then((response) => {
              customToast("Seu ponto foi registrado!", "success");
              navigate("/home");
            })
            .catch((error: any) => {
              if (isTryAgain) {
                setLoading(false);
                navigate("/home");
                customToast(
                  `${
                    error?.response?.data?.message || "Erro ao cadastrar ponto"
                  }`,
                  "error"
                );
              } else {
                setTimeout(() => {
                  handleSend(true);
                }, 1000);
              }
            });
        },
        function (error) {
          if (error.code === error.PERMISSION_DENIED) {
            Swal.fire({
              icon: "error",
              title: "Sua localização esta desabilitada!",
              text: "Para que possamos registrar seu ponto, é necessário que você habilite a localização no seu dispositivo. Por favor, vá às configurações do seu navegador ou dispositivo e habilite a localização.",
            });
          } else {
            customToast(
              "Erro ao cadastrar ponto. Por favor, habilite a localização.",
              "error"
            );
          }
          setLoading(false);
          navigate("/home");
        }
      );
    },
    [image, navigate, userData]
  );

  return (
    <Layout>
      <div className={style.containerAll}>
        {!loading && (
          <div className={style.container} onClick={backPage}>
            <ArrowBackPage />
          </div>
        )}

        {!image && (
          <Webcam
            videoConstraints={{ facingMode: "user" }}
            className={style.camera}
            audio={false}
            ref={webcamRef}
            style={{
              width: "100%",
              height: "60vh",
              objectFit: "contain",
            }}
            mirrored={true}
            screenshotFormat="image/jpeg"
          />
        )}
        {image && (
          <img
            style={{
              width: "100%",
              height: "60vh",
              objectFit: "contain",
            }}
            src={image}
            alt="selfie"
          />
        )}
        {!image && (
          <ButtonCaptureCamera
            onClick={capture}
            component={<AiFillCamera size={40} />}
          />
        )}
        {image && !loading && (
          <Box className={style.buttons}>
            <button onClick={() => handleSend()} disabled={loading}>
              <SiVerizon size={20} />
            </button>
            <button onClick={handleClose} disabled={loading}>
              {" "}
              <IoMdClose fontSize={30} />{" "}
            </button>
          </Box>
        )}
        <IfLoaderInsideScreen loading={loading} />
      </div>
    </Layout>
  );
}
export function dataURLtoFile(dataurl: any, filename: any) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}
